import { render, staticRenderFns } from "./debug-tab.vue?vue&type=template&id=9177e0a4&lang=html&"
import script from "./debug-tab.vue?vue&type=script&lang=js&"
export * from "./debug-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports